import React from 'react';

// import EarthDayPreRegisterPage_3CE2022 from "../preregister/2022-3ce-earthday.js";
// import EarthDayPreRegisterPage_3CE2022 from "../../3ce/CampaignComponents/2022-3ce-earthday/pre-register-landing/2022-3ce-earthday-PreRegisterPage.js";
import CampaignPage_2022_3ce_earthday from "../../3ce/CampaignComponents/2022-3ce-earthday/campaign-landing/CampaignPage_2022_3ce_earthday.js";

// Once the campaign launches, this file will be replaced with the actual campaign landing page.

function Campaign(props) {

    return (
        <CampaignPage_2022_3ce_earthday />
    )
};

export default Campaign;